(() => {
  if (customElements.get('yoko-card-wishlist')) return;
  // Render the icon in Liquid. Wishlist Engine still owns state and persistence.
  customElements.define('yoko-card-wishlist', class extends HTMLElement {
    connectedCallback() {
      this.control = this.querySelector('.wishlist-engine');
      if (!this.control) return;
      this.activate = (event) => {
        if (this.ready()) return;
        // The app loads its configuration asynchronously. Keep an early click
        // and replay it once, only after the app has restored the saved state.
        event.preventDefault();
        event.stopImmediatePropagation();
        this.pending = true;
        this.control.setAttribute('aria-busy', 'true');
      };
      this.keyboard = (event) => {
        if (event.target !== this.control || !['Enter', ' '].includes(event.key) || event.repeat) return;
        event.preventDefault();
        this.control.click();
      };
      this.control.addEventListener('click', this.activate, true);
      this.control.addEventListener('keydown', this.keyboard);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.control, { attributes:true, attributeFilter:['data-added', 'data-apply-event'] });
      this.sync();
    }
    ready() {
      return this.control.dataset.applyEvent === 'true' && ['true', 'false'].includes(this.control.dataset.added);
    }
    sync() {
      const added = this.ready()
        ? this.control.getAttribute('data-added') === 'true'
        : (window.yokoWishlistInitialIds || []).includes(this.control.dataset.product_id);
      this.control.setAttribute('aria-pressed', String(added));
      this.control.setAttribute('aria-label', added ? this.control.dataset.yokoRemoveLabel : this.control.dataset.yokoAddLabel);
      if (this.ready() && this.pending) {
        this.pending = false;
        this.control.removeAttribute('aria-busy');
        this.control.click();
      }
    }
    disconnectedCallback() {
      this.pending = false;
      this.control?.removeEventListener('click', this.activate, true);
      this.control?.removeEventListener('keydown', this.keyboard);
      this.observer?.disconnect();
    }
  });
})();

